import React from "react";
import AuthService from '../Auth/AuthService';
import AdminDashboard from "../dashboard/AdminDashboard";
import AttendanceView from "../emp-components/attendance/AttendanceView";


export default function UserHome() {
    let tokendata = AuthService.tokenInfoNew();
    let userId = tokendata?.Id; //loginId

    return (
        <div>
            {tokendata?.roles === "ADMIN" && (
                <AdminDashboard />
            )}
            {tokendata?.roles === "TEACHER" && (
                <AttendanceView empId={0} user={tokendata} />
            )}
            {tokendata?.roles === "Marriage" && (
                { userId }
            )};
        </div>

    );
}
